import cx from "classnames"
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import parseYoutubeIdFromUrl from "lib/validateYoutubeUrl"

function YoutubeVideo({ className, url, autoPlay }) {
  const id = parseYoutubeIdFromUrl(url)

  const [videoUrl, setVideoUrl] = useState(
    `https://www.youtube.com/embed/${id}`
  )

  useEffect(() => {
    if (autoPlay) {
      setVideoUrl(`${videoUrl}?showinfo=0&enablejsapi=1&autoplay=1`)
    }
  }, [])

  return (
    <span className={cx("relative block aspect-video bg-black", className)}>
      {id ? (
        <iframe
          className="absolute left-0 top-0 h-full w-full"
          title="Youtube video"
          width="560"
          height="315"
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; compute-pressure"
          referrerPolicy="strict-origin-when-cross-origin" // Add this line
          allowFullScreen
        />
      ) : (
        <p>Error: could not parse YouTube URL.</p>
      )}
    </span>
  )
}

YoutubeVideo.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
  /** YouTube video URL */
  url: PropTypes.string,
  /** If true, play the video immediately */
  autoPlay: PropTypes.bool,
}

export default YoutubeVideo
